import React, {FC} from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {useField, useFormikContext, getIn} from 'formik'
import {KTIcon} from '../../../_metronic/helpers'
import {ErrorMessage} from 'formik'
type InputDatePickerProps = {
  value?: Date
  touched: {}
  name: string
  label: string
  errors: {}
  required?: boolean
  fields?: any
  placeholder?: string
}
const InputDatePicker: FC<InputDatePickerProps> = ({
  errors,
  label,
  name,
  required = true,
  touched,
  fields,
  placeholder = '',
}) => {
  const {setFieldValue} = useFormikContext() ?? {}
  const [field] = useField(name)
  const submit_form = getIn(touched, name)
  const submit_form_error = getIn(errors, name)
  return (
    <>
      <label className={'form-label ' + (required ? 'required' : '')}>{label}</label>
      <div className='position-relative'>
        <DatePicker
          className='form-control form-control-solid'
          placeholderText={placeholder}
          dateFormat={'dd/MM/yyyy'}
          selected={(field.value && new Date(field.value)) || null}
          onChange={(val) => {
            setFieldValue(field.name, val)
          }}
        />
        <div className='position-absolute translate-middle-y top-50 end-0 me-3 '>
          {submit_form && !submit_form_error ? (
            <KTIcon iconName='check' iconType='solid' className='fs-2hx text-success' />
          ) : submit_form ? (
            <KTIcon iconName='cross' iconType='solid' className='fs-2hx text-danger' />
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className='text-danger mt-2'>
        <ErrorMessage data-testid={name} name={name} />
      </div>
    </>
  )
}

export default InputDatePicker
